import type { Corner, PlannedShot } from "./types"

// "Like this": what the asked-for photo looks like. Whole-car corners are
// renders of the licensed model the marketing site uses, one per corner, so
// each shows exactly the angle asked for (public/intake-examples/README.md).
// Damage shots use real stock photos (public/demo-photos, Pexels licence).

export interface ExamplePhoto {
  src: string
  alt: string
  // Where the car sits in the image (0–1) — the brackets frame it, the same
  // way the live camera frames the real car.
  frame: { x: number; y: number; w: number; h: number } | null
}

// From scripts/intake-examples/render-corners.mjs (printed per render).
const CORNER_FRAME = { x: 0.114, y: 0.404, w: 0.772, h: 0.264 }

const CORNER_EXAMPLE: Record<Corner, ExamplePhoto> = {
  FL: { src: "/intake-examples/corner-fl.jpg", alt: "The whole car, seen from its front corner on the driver's side", frame: CORNER_FRAME },
  FR: { src: "/intake-examples/corner-fr.jpg", alt: "The whole car, seen from its front corner on the passenger side", frame: CORNER_FRAME },
  RR: { src: "/intake-examples/corner-rr.jpg", alt: "The whole car, seen from its back corner on the passenger side", frame: CORNER_FRAME },
  RL: { src: "/intake-examples/corner-rl.jpg", alt: "The whole car, seen from its back corner on the driver's side", frame: CORNER_FRAME },
}

export function exampleFor(shot: PlannedShot): ExamplePhoto | null {
  switch (shot.kind) {
    case "wide":
      return shot.corner ? CORNER_EXAMPLE[shot.corner] : null
    case "closer":
      return { src: "/demo-photos/e66-front.jpg", alt: "The damaged part of a car filling most of the photo", frame: null }
    case "closeup":
      return { src: "/demo-photos/e66-front-closeup.jpg", alt: "A close-up of damage filling the photo", frame: null }
    case "sticker":
      return null
  }
}
